'use strict';

exports.__esModule = true;

var _pull = require('nanotools/lib/pull');

var _pull2 = _interopRequireDefault(_pull);

var _emptySubscription = require('./emptySubscription');

var _emptySubscription2 = _interopRequireDefault(_emptySubscription);

var _defineObservable = require('./defineObservable');

var _defineObservable2 = _interopRequireDefault(_defineObservable);

var _subscribeObserverAdapter = require('./subscribeObserverAdapter');

var _subscribeObserverAdapter2 = _interopRequireDefault(_subscribeObserverAdapter);

var _createSubscription = require('./createSubscription');

var _createSubscription2 = _interopRequireDefault(_createSubscription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 1.12.6
var createSubject,
    indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) return i;
  }return -1;
};

exports.default = createSubject = function (opts) {
  var complete, error, hasError, isStopped, next, observers, onObserverStarted, onObserversChanged, subscribe, thrownError;
  onObserversChanged = opts != null ? opts.onObserversChanged : void 0;
  onObserverStarted = opts != null ? opts.onObserverStarted : void 0;
  observers = [];
  hasError = false;
  thrownError = null;
  isStopped = false;
  next = function (x) {
    var i, len, observer, ref;
    if (!isStopped) {
      ref = observers.slice();
      for (i = 0, len = ref.length; i < len; i++) {
        observer = ref[i];
        if (typeof observer.next === "function") {
          observer.next(x);
        }
      }
    }
  };
  error = function (x) {
    var i, len, observer, ref;
    if (!isStopped) {
      hasError = true;
      thrownError = x;
      isStopped = true;
      ref = observers.slice();
      for (i = 0, len = ref.length; i < len; i++) {
        observer = ref[i];
        if (typeof observer.error === "function") {
          observer.error(x);
        }
      }
    }
  };
  complete = function () {
    var i, len, observer, ref;
    if (!isStopped) {
      isStopped = true;
      ref = observers.slice();
      for (i = 0, len = ref.length; i < len; i++) {
        observer = ref[i];
        if (typeof observer.complete === "function") {
          observer.complete();
        }
      }
    }
  };
  subscribe = (0, _subscribeObserverAdapter2.default)(function (observer) {
    var sub;
    if (hasError) {
      if (typeof observer.start === "function") {
        observer.start(_emptySubscription2.default);
      }
      if (typeof observer.error === "function") {
        observer.error(thrownError);
      }
      return _emptySubscription2.default;
    } else if (isStopped) {
      if (typeof observer.start === "function") {
        observer.start(_emptySubscription2.default);
      }
      if (typeof observer.complete === "function") {
        observer.complete();
      }
      return _emptySubscription2.default;
    } else {
      observers.push(observer);
      if (typeof onObserversChanged === "function") {
        onObserversChanged(observers, observer, null);
      }
      sub = (0, _createSubscription2.default)(observer, function () {
        if ((0, _pull2.default)(observers, observer)) {
          if (typeof onObserversChanged === "function") {
            onObserversChanged(observers, null, observer);
          }
        }
      });
      if (typeof observer.start === "function") {
        observer.start(sub);
      }
      if (indexOf.call(observers, observer) >= 0) {
        if (typeof onObserverStarted === "function") {
          onObserverStarted(observer, observers);
        }
      }
      return sub;
    }
  });
  return (0, _defineObservable2.default)({
    next: next,
    error: error,
    complete: complete,
    subscribe: subscribe
  });
};